import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import {
  ProcedureConsumableInput,
  RequestProcedureResponse,
} from "@/types";

export type CreateProcedureRequestDTO = {
  name: string;
  value: string;
  stock_items: ProcedureConsumableInput[];
};

async function createProcedure(
  request: CreateProcedureRequestDTO
): Promise<RequestProcedureResponse> {
  const response = await httpRequest.post<RequestProcedureResponse>(
    "/procedures",
    request
  );
  return response.data;
}

export function useCreateProcedureMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createProcedure,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["procedures"] });
    },
  });
}
